import { IAssetTypeDefinition } from '../types';

export const getDataType = (property: string, assetTypeDefinitions: IAssetTypeDefinition[]): IAssetTypeDefinition['dataType'] | undefined =>
  assetTypeDefinitions.find(def => def.columnName === property)?.dataType;
